import React from 'react';
import banner from './img/courses-bannner.png'
import './CCNAPage.css';
import CareerForm from './careerform';
import Footer from '../Components/footer'

const CCNAPage = () => {
  return (
    <div className='cisco-container'>
       <div className='cisco-banner-box'>
                  <div className='cisco-banner'>
        <img src={banner} alt=''/>
                  </div>
                </div>

<div className='detail-box'>
    <div className='cisco-heading'>
        <h1>Cisco Certified Network Associate (CCNA) Course </h1>
        <p>The CCNA (Cisco Certified Network Associate) course is a powerful networking program that builds strong, job-ready IT skills.
Learn how to set up, configure, and troubleshoot networks used in real-world environments.
Gain practical knowledge of networking technologies and security implementation.
Work on hands-on labs and real-time simulations to build true industry experience.
Boost your confidence with skills that top companies are actively hiring for.
Start today and take your first step toward a successful and high-growth career in networking.

</p>
        </div > 
        <div className='carrer-section'>
        <div className='skills-section'>
<h2>🛡️ Top CCNA Skills You’ll Master</h2>
<div className='skills-name'>
<span>Network fundamentals and protocols</span>
<span>IP addressing and subnetting</span>
</div>
<div className='skills-name'>
<span>Routing protocols (Static, OSPF)</span>
<span>Switching and VLAN configuration</span>
</div>
<div className='skills-name'>
<span>Network security fundamentals</span>
</div>

        </div>
         <div className='job-roles'>
           <h1>💼 JOB ROLES AFTER CCNA COURSE  </h1>
           <div className='job-name'>
            <span>Red Team Engineer</span>
            <span>SOC Analyst (L2/L3)</span>
            </div>
             <div className='job-name'>
            <span>SOC Analyst (L2/L3)</span>
            <span>Security Consultant</span>
            </div>
             <div className='job-name'>
            <span>Bug Bounty Hunter</span>
           </div>
        </div>
        </div>
        <div className='course-discription'>
            <h1>About this Course</h1>
<p>The CCNA (Cisco Certified Network Associate) course is a globally recognized program that builds a strong foundation in modern networking.
If you dream of entering the IT field, this course is your perfect first step.
Learn core networking concepts used in real-world IT environments.
Master network setup, configuration, and management with practical understanding.
Understand routing, switching, IP addressing, and network security easily.
This course focuses on real skills that companies are actively looking for.
Gain hands-on experience through live labs and real-time simulations.
Work on practical scenarios that prepare you for real job roles.
Develop strong troubleshooting skills to solve network issues confidently.
Boost your confidence with industry-relevant knowledge and tools.
Stand out in the job market with a valuable and trusted certification.
Ideal for students, freshers, and professionals who want career growth.
Unlock opportunities in networking, IT support, and system administration.
Turn your passion for technology into real, job-ready skills.
Start today and build a successful, secure, and high-growth career in IT.

</p>
        </div>
        </div>
        <div className='join-container'>
        <div className='join-box'>
<div className='join-div'>
<h1>Who Should Join this CCNA Course</h1>
<p><span> ✔ </span>Students who want to start a career in networking from zero level. </p>
<p><span> ✔ </span>Freshers looking to enter IT with practical network skills.</p>
<p><span> ✔ </span>Beginners who want to understand how internet & networks really work. </p>
<p><span> ✔ </span>Tech learners ready to build a strong base in routing & switching.</p>
<p><span> ✔ </span> IT beginners aiming for job-ready skills in networking field.</p>
<p><span> ✔ </span>Working professionals planning to move into networking roles.</p>
<p><span> ✔ </span>Support engineers who want to upgrade into network expert level. </p>
<p><span> ✔ </span>Freelancers who want to offer network setup & support services.</p>
<p><span> ✔ </span> Self-learners searching for a clear and simple learning path in networking.</p>
<p><span> ✔ </span>Anyone who wants a stable, growing and future-proof IT career.</p>
</div>
        </div>

                <CareerForm/>
        </div>

    <div className="modules-container">

      {/* Heading */}
      <h1 className="module">Course RoadMap</h1>
      <p className="subtitle">
        Step-by-step modules to master CCNA Course
      </p>

      {/* Grid */}
      <div className="modules-grid">

        {/* Card 1 */}
        <div className="module-card">
          <div className="circle">01</div>
          <h3>Network Fundamentals</h3>
          <p>
            Learn basic networking concepts, models, and essential network device functions.
          </p>
        </div>

        {/* Card 2 */}
        <div className="module-card">
          <div className="circle">02</div>
          <h3>IP Addressing</h3>
          <p>
           Understand IPv4, IPv6, subnetting, and CIDR for efficient network addressing.
          </p>
        </div>

        {/* Card 3 */}
        <div className="module-card">
          <div className="circle">03</div>
          <h3>Routing & Switching</h3>
          <p>
           Explore routing protocols, switching concepts, and MAC address table operations.
          </p>
        </div>

        {/* Card 4 */}
        <div className="module-card">
          <div className="circle">04</div>
          <h3>VLANs & Inter-VLAN Routing</h3>
          <p>
           Configure VLANs, trunking, and enable communication between different network segments.
          </p>
        </div>

        {/* Card 5 */}
        <div className="module-card">
          <div className="circle">05</div>
          <h3>Network Services</h3>
          <p>
           Learn DHCP, DNS, NAT, and NTP for essential network service management.
          </p>
        </div>

        {/* Card 6 */}
        <div className="module-card">
          <div className="circle">06</div>
          <h3>Network Security</h3>
          <p>
          Implement ACLs, port security, and basic firewall protection techniques effectively.
          </p>
        </div>

      </div>

        {/* Grid */}
      <div className="modules-grid">

        {/* Card 7 */}
        <div className="module-card">
          <div className="circle">07</div>
          <h3>WAN Technologies</h3>
          <p>
          Understand PPP, MPLS basics, and introductory concepts of secure VPN connections.
          </p>
        </div>

        {/* Card 8 */}
        <div className="module-card">
          <div className="circle">08</div>
          <h3>Wireless Networking</h3>
          <p>
           Learn Wi-Fi standards, wireless security, and access point configuration basics.
          </p>
        </div>

        {/* Card 9 */}
        <div className="module-card">
          <div className="circle">09</div>
          <h3>Automation & Programmability</h3>
          <p>
          Explore network automation basics and introduction to APIs for modern networking.
          </p>
        </div>

        {/* Card 10 */}
        <div className="module-card">
          <div className="circle">10</div>
          <h3>Practical (CCNA)</h3>
          <p>
            Practice router configuration, topology design, troubleshooting using Packet Tracer labs.
          </p>
        </div>


      </div>
    </div>

<div>
        <Footer/>
</div>
    </div>
  )
}

export default CCNAPage
